import React, { useState } from "react"
import { useQuery } from "@apollo/client"
import { Input } from "reactstrap"

import EditPopover, { useDocumentFieldSave } from "./EditPopover"
import { IncidentDocumentTypesQuery } from "./queries"

/**
 * Change which type a document is filed under.
 *
 * The list is scoped to the category the document already sits in -- a party document
 * can only become another party document type -- because the type's category and the
 * document's slug have to agree for it to keep showing up in the same place afterwards.
 */
const EditDocumentTypePopover = ({ open, target, documentId, category, currentTypeId, handleClose, onSaved }) => {
    const [selected, setSelected] = useState(currentTypeId || "")
    const { save, saving, error } = useDocumentFieldSave(documentId, onSaved, handleClose)
    const { data, loading } = useQuery(IncidentDocumentTypesQuery, { variables: { category } })

    const types = ((data && data.allIncidentDocumentTypes && data.allIncidentDocumentTypes.edges) || [])
        .map((edge) => edge.node)

    return (
        <EditPopover
            open={open}
            target={target}
            label="Document type"
            inputId="idm-document-type"
            hint={`Only ${String(category).toLowerCase()} types are listed.`}
            error={error}
            saving={saving}
            canSave={!!selected && selected !== currentTypeId}
            onClose={handleClose}
            onSave={() => save({ documentType: selected }, "Couldn't change the document type.")}
        >
            <Input
                type="select"
                id="idm-document-type"
                className="idm-popover-input"
                value={selected}
                disabled={loading || saving}
                onChange={(e) => setSelected(e.target.value)}
            >
                <option value="">{loading ? "Loading types…" : "Choose a type"}</option>
                {types.map((type) => (
                    <option key={type.id} value={type.id}>{type.name}</option>
                ))}
            </Input>
        </EditPopover>
    )
}

export default EditDocumentTypePopover
